import { ObservationDto } from '../../coaching-base/general';
import { ObjectDateTransformer } from '../../coaching-insight/coaching-insight.model';
import { ModelTransformer } from '../../common/common.model';

export class ObservationDtoTransformer
    implements ModelTransformer<ObservationDto, ObservationDto>
{
    transform(model: ObservationDto): ObservationDto {
        const dateTransformer = new ObjectDateTransformer<ObservationDto>({
            event: {
                sessionDate: null,
                createdOn: null,
                updatedOn: null,
                startTime: null,
                endTime: null,
            },
            focusContainers: {
                interactions: {
                    interactionDateTime: null,
                    createdOn: null,
                    updatedOn: null,
                    notes: {
                        createdOn: null,
                        publishedOn: null,
                    },
                },
            },
        });
        return dateTransformer.transform(model);
    }
}
